import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import IconButton from '@material-ui/core/IconButton';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 80,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const Toolbar = () => {
  const classes = useStyles();
  const [age, setAge] = useState()
  const [selectedValue, setSelectedValue] = useState('a');

  return (
    <div className='radioInput'>
      <div className="firstLine">
        {/* <select>
          <label>Sort by</label>
          <option>Option 1</option>
          <option>Option 1</option>
          <option>Option 1</option>
        </select> */}
        <div>
          <FormControl component="fieldset">
            <RadioGroup row aria-label="position" name="position" defaultValue="top">
              <FormControlLabel value="year" control={<Radio color="primary" />} label="Տարի" />
              <FormControlLabel value="month" control={<Radio color="primary" />} label="Ամիս" />
              <FormControlLabel value="week" control={<Radio color="primary" />} label="Շաբաթ" />
              <FormControlLabel value="day" control={<Radio color="primary" />} label="Օր" />
            </RadioGroup>
          </FormControl>
        </div>
        <div>
          <IconButton
            aria-label="more"
            aria-controls="long-menu"
            aria-haspopup="true"
          // onClick={handleClick}
          >
            <AccountCircleIcon />
          </IconButton>
        </div>
      </div>




      <div>
        <FormControl className={classes.formControl}>
          <InputLabel id="demo-simple-select-label">Sort by</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={age}
          // onChange={handleChange}
          >
            <MenuItem value={10}>Option1</MenuItem>
            <MenuItem value={20}>Option2</MenuItem>
            <MenuItem value={30}>Option3</MenuItem>
          </Select>
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel id="demo-simple-select-label">Տարի</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={age}
          // onChange={handleChange}
          >
            <MenuItem value={10}>2020</MenuItem>

          </Select>
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel id="demo-simple-select-helper-label">Ամիս</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            value={age}
          // onChange={handleChange}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            <MenuItem value={10}>Հունվար</MenuItem>
            <MenuItem value={20}>Փետրվար</MenuItem>
            <MenuItem value={30}>Մարտ</MenuItem>
            <MenuItem value={30}>․․․</MenuItem>
          </Select>
          {/* <FormHelperText>Some important helper text</FormHelperText> */}
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel id="demo-simple-select-helper-label">Օր</InputLabel>
          <Select
            value={age}
            // onChange={handleChange}
            displayEmpty
            className={classes.selectEmpty}
            inputProps={{ 'aria-label': 'Without label' }}
          >
            <MenuItem value="">
              <em>Օր</em>
            </MenuItem>
            <MenuItem value={10}>1</MenuItem>
            <MenuItem value={20}>2</MenuItem>
            <MenuItem value={30}>3</MenuItem>
          </Select>
          {/* <FormHelperText>Without label</FormHelperText> */}
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel id="demo-simple-select-placeholder-label-label">
            Շաբաթ
    </InputLabel>
          <Select
            labelId="demo-simple-select-placeholder-label-label"
            id="demo-simple-select-placeholder-label"
            value={age}
            // onChange={handleChange}
            displayEmpty
            className={classes.selectEmpty}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            <MenuItem value={10}>Երկուշաբթի</MenuItem>
            <MenuItem value={20}>Երեքշաբթի</MenuItem>
            <MenuItem value={30}>Չորեքշաբթի</MenuItem>
            <MenuItem value={30}>․․․</MenuItem>
          </Select>
          {/* <FormHelperText>Label + placeholder</FormHelperText> */}
        </FormControl>
      </div>


    </div>

  )



}
export default Toolbar;
